import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ComProductCollectAmountModel } from 'src/app/model/com-product-collect-amount.model';

@Injectable({
  providedIn: 'root'
})
export class ComProductCollectAmountService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  //
  getAll=()=> {
    return this.http.get(`${this.url}/CommissionProductCollectAmount/List`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  
  save=(commission:ComProductCollectAmountModel)=> {
    return this.http.post(`${this.url}/CommissionProductCollectAmount/SaveUpdate`, commission)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  saveAll=(commissions:ComProductCollectAmountModel[])=> {
    return this.http.post(`${this.url}/CommissionProductCollectAmount/saveAll`, commissions)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  update=(commission:ComProductCollectAmountModel)=> {
    return this.http.post(`${this.url}/CommissionProductCollectAmount/SaveUpdate/${commission.collectAmountId}`, commission)
      .pipe(
        map((resp:any)=> resp)
      );
  }
}
